module.exports = __webpack_public_path__ + "static/media/observer-perspective-large@2x.72c7892e.png";